<script>
export default {
  locales: {
    pt: {
      'Sorry, page not found': 'Desculpe, página não encontrada',
      'Back to Dashboard': 'Voltar ao Painel',
    },
    es: {
      'Sorry, page not found': 'Lo sentimos, página no encontrada',
      'Back to Dashboard': 'Volver al Panel',
    },
  },
}
</script>

<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <h1 class="display-2 font-weight-medium">
              4<i class="bx bx-buoy bx-spin text-danger display-3"></i>4
            </h1>
            <h4 class="text-uppercase">{{ t('Sorry, page not found') }}</h4>
            <div class="mt-5 text-center">
              <router-link tag="a" class="btn btn-dark" to="/">{{ t('Back to Dashboard') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>